//后面原则上，翻译部分能用首字母大写的就首字母大写，这样即使在程序中需要使用全小写也可以直接toLowerCase()，
// 如果全小写的情况下又需要首字母大写就不太好弄
// ，当然如果基本能够确定没有问题的就可以全小写
//为了方便纯翻译的部分就不再额外写一份英文了（直接用key），所以直接最后导出zh 和当前en的一个merge
import zh from './zh_CN';
let keys = {};
for(let x in zh){
    keys[x] = x;
}
const en = {
    'demo':"this is a demo",
    // 'Success':'Success',
    // 'Expand':'Expand',
    // 'Fold':'Fold',
    'Confirm':'Confirm',
    'Processing':'processing',
    'ok':'Ok',
    'all':'All',
    'nCol':'{num, plural,  =1 {1 Column} other {# Columns}}',
    'chronological':'chronological sort',
    'all-in-one':'All in one',
    // 'mine':'mine',
    'hide':'Hide',
    'show':'Show',
    'cancel':'Cancel',
    // 'loading':'loading',
    // 'tip':'tip',
    'long-press-to-save':'Long press to save, and forward to Moments',
    'long-press-to-save-1':'Long press to save',
    'time':'Time',
    'place':'Place',
    'slide-up':'Slide Up',
    'wrong-pass':'Sorry, wrong password! Please check!',
    'speaker-guest':'Speakers/Guests',
    'live-photo':'LIVE PHOTO',
    'live-video':'LIVE VIDEO',
    'fast-editing':'FAST EDITING',
    'details':'Details',
    'agenda':'Agenda',
    'organizer':'Organizer',
    'Introduction':'Introduction',
    // 'Time':'Time',
    // 'Place':'Place',
    'Recently-visited':'Recently visited',
    // 'Go':'Go',
    'History album':'History album',
    // 'Album':'Album',
    // 'Like':'Like',
    'all-in-one-image':"'all-in-one' image",
    'Click to view':'Go',//直接用Go了
    'Confirm deletion':'Confirm deletion?',
    'Album-OK':'OK',
    'Album-Cancel':'Cancel',
    // 'Back':'Back',
    // 'Loaded':'Loaded',
    //预约部分
    'Phone-Is-required':'Phone is required',
    'Name-Is-required':'Name is required',
    'City-Is-required':'City is required',
    'Date-Is-required':'Date is required',
    'PreOrder-Name':'Name',
    'PreOrder-Phone':'Phone',
    'PreOrder-City':'City',
    'PreOrder-Start':'Start date',
    'PreOrder-End':'Last date',
    'PreOrder-Main':'Contact us',
    'PreOrder-Hotline':'Hotline',
    'PreOrder-Tip':'Please keep your phone open, we will contact you as soon as possible.',
    'Please select service type':'Please select service type',
    'Date not right':'Ending date should be later than starting date',
    'Order fails':'Order fails, please call custom service',
    //大图
    'Full image':'Full image',
    'BigPic-Likes':'{num, plural, =0 {like} =1 {# like} other {# likes}}',
    //代码中的字符串
    'Not Started':'Not Started',
    'Ascending':'Ascending',
    'Descending':'Descending',
    'Order received':'Order received',
    'MAX_JIGSAW_NUM':'{num, plural, =1 {# photo} other {# photos}} could be split jointed at most by now',
    'min-jigsaw':'{num, plural, =1 {# photo} other {# photos}} at least for collage',
    'Collaging':'Collaging...',
    'No more photos':'No more photos',
    'photo update':'{num, plural,  =1 {1 photo} other {# photos}} updated',
    'share-default':'Jimage live photo, makes each shared moment wonderful!',
    //我的影集相关
    'my-album':'My album',
    'in-album':'Go',
    // 'Modify':'Modify',
    // 'Delete':'Delete',
    'photo':'{num, plural, =0 {Photo} =1 {Photo} other {Photos}}',
    'photos':'{num, plural, =0 {photo} =1 {photo} other {photos}}',
    'photos2':'{num, plural, =0 {photo} =1 {photo} other {photos}}',
    'album':'{num, plural, =0 {Album} =1 {Album} other {Albums}}',
    'all album':'All Album',
    'current album':'Current Album',
    'My friends':'My friends',
    'Add friends':'Add friends',
    'album-tip':'TIPS',
    'album-tip-content':'For better facial recognition, please upload the unobscured, unbeautified, clear frontal portrait',
    'album-tip-content2':'',//空，原因见中文部分
    'Delete friend':'Delete friend?',
    'Max friend number':'The number of your friends has reached to 6, please delete someone if you want to add a new one.',
    'Max friend number2':'',
    'Name placeholder':'Name',
    'Name is required':'Name is required',
    '+friends':'+friends',
    'Know him/her':'Know him/her?',
    'No photos':'No photos',
    'HideAvatar':'Hide',
    'ShowAvatar':'Show',
    'Wrong recognition':'Wrong recognition',
    'Please upload single frontal photo':'Please upload your photo, and make sure the frame is full filled with your front face',
    'after upload':'Please upload your photo, and make sure the frame is full filled with your front face, changing is not available after upload',
    'Changing frontal photo is not available now':'Changing frontal photo is not available now',
    'Upload and agree':'Upload and agree',
    'Jfoto service agreement':'Jfoto service agreement',
    'for better service':'for better service',
    'Please read and agree to the agreement firstly':'Please read and agree to the agreement firstly',
    'no sb':'Is there no {name} in this photo?',
    'Deleting is beyond retrieve':'Deleting is beyond retrieve',
    'photo of x':"{name}'s album",
    'detail avatar tip':'Click the portrait to review all photos of him/her in current album',
    'Guide':'Guideline',
    'click the wrong recognition button':'Click the pictures below, and then click the "wrong recognition" button to delete the wrong recognized image.',
    //评论相关

    //弹幕
    'DanmakuOn':'On',
    'DanmakuOff':'Off',
}

export default {
    ...keys,
    ...en,
};



// WEBPACK FOOTER //
// ./src/locale/en.js